module.exports = __webpack_public_path__ + "static/media/NEXT-Banner.16b834d3.svg";